<!-- BEGIN: Left Aside -->
<button class="m-aside-left-close  m-aside-left-close--skin-dark" id="m_aside_left_close_btn" appunwraptag="">
    <i class="la la-close"></i>
</button>
<div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-dark">
    <!-- BEGIN: Aside Menu -->
    <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark"
        data-menu-vertical="true" data-menu-scrollable="false" data-menu-dropdown-timeout="500">
        <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow">
            <li *ngIf="canAccess('/index')" class="m-menu__item  " routerLinkActive="m-menu__item--active" [routerLinkActiveOptions]="{ exact: true }"
                aria-haspopup="true">
                <a routerLink="/index" class="m-menu__link">
                    <i class="m-menu__link-icon la la-home"></i>
                    <span class="m-menu__link-title">
                        <span class="m-menu__link-wrap">
                            <span class="m-menu__link-text">
                                Home
                            </span>

                        </span>
                    </span>
                </a>
            </li>
<!--
            <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open m-menu__item--active"
                [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true" data-menu-submenu-toggle="hover">
                <a routerLink="/analytics" class="m-menu__link m-menu__toggle">
                    <i class="m-menu__link-icon fa fa-line-chart"></i>
                    <span class="m-menu__link-text">
                        Analytics
                    </span>
                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                </a>
                <div class="m-menu__submenu">
                    <span class="m-menu__arrow"></span>
                    <ul class="m-menu__subnav">
                        <li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <span class="m-menu__link">
                                <span class="m-menu__link-text">
                                    Analytics
                                </span>
                            </span>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/analytics/access-statistics" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Access
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/analytics/connection-statistics" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Connection
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/analytics/traffic-statistics" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Traffic
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
-->
            <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open m-menu__item--active"
                [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true" data-menu-submenu-toggle="hover">
                <a routerLink="/administration" class="m-menu__link m-menu__toggle">
                    <i class="m-menu__link-icon flaticon-interface-8"></i>
                    <span class="m-menu__link-text">
                        Administration
                    </span>
                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                </a>
                <div class="m-menu__submenu">
                    <span class="m-menu__arrow"></span>
                    <ul class="m-menu__subnav">
                        <li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <span class="m-menu__link">
                                <span class="m-menu__link-text">
                                    Administration
                                </span>
                            </span>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/tenants" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Tenants
                                </span>
                            </a>
                        </li>
                        <!-- <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/channel" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Channels
                                </span>
                            </a>
                        </li> -->
                        <li *ngIf="canAccess('/administration/email-models')" class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/email-models" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Email Models
                                </span>
                            </a>
                        </li>
                        <li *ngIf="canAccess('/administration/email-senders')" class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/email-senders" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Email Senders
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/policies" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Policies
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/user_groups" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    User Groups
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/location-groups" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Locations Groups
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/locations" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Locations
                                </span>
                            </a>
                        </li>
                        <li *ngIf="canAccess('/administration/radius')" class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/radius" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Radius
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/captive-portal" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Captive Portals
                                </span>
                            </a>
                        </li>
                        <li *ngIf="canAccess('/administration/strategies')" class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/strategies" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Strategies
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/administration/network-device-interface" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Network Device Interface
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open m-menu__item--active"
                [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true" data-menu-submenu-toggle="hover">
                <a routerLink="/captive-portal" class="m-menu__link m-menu__toggle">
                    <i class="m-menu__link-icon flaticon-imac"></i>
                    <span class="m-menu__link-text">
                        Captive Portal
                    </span>
                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                </a>
                <div class="m-menu__submenu">
                    <span class="m-menu__arrow"></span>
                    <ul class="m-menu__subnav">
                        <li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <span class="m-menu__link">
                                <span class="m-menu__link-text">
                                    Captive Portal
                                </span>
                            </span>
                        </li>
                        <li *ngIf="canAccess('/captive-portal/strategies')" class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/captive-portal/strategies" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Strategies
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/captive-portal/pages" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Captive Portal Pages
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open m-menu__item--active"
                [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true" data-menu-submenu-toggle="hover">
                <a routerLink="/device" class="m-menu__link m-menu__toggle">
                    <i class="m-menu__link-icon flaticon-network"></i>
                    <span class="m-menu__link-text">
                        Device
                    </span>
                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                </a>
                <div class="m-menu__submenu">
                    <span class="m-menu__arrow"></span>
                    <ul class="m-menu__subnav">
                        <li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <span class="m-menu__link">
                                <span class="m-menu__link-text">
                                    Device / Vendor
                                </span>
                            </span>
                        </li>
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/device" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Device
                                </span>
                            </a>
                        </li>
                        <li *ngIf="canAccess('/device/vendor')" class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/device/vendor" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Vendor
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open m-menu__item--active"
                [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true" data-menu-submenu-toggle="hover">
                <a routerLink="/sessions" class="m-menu__link m-menu__toggle">
                    <i class="m-menu__link-icon flaticon-network"></i>
                    <span class="m-menu__link-text">
                        Sessions (alpha)
                    </span>
                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                </a>
                <div class="m-menu__submenu">
                    <span class="m-menu__arrow"></span>
                    <ul class="m-menu__subnav">
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/sessions" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Sessions
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="m-menu__submenu">
                    <span class="m-menu__arrow"></span>
                    <ul class="m-menu__subnav">
                        <li class="m-menu__item" routerLinkActive="m-menu__item--active"
                            [routerLinkActiveOptions]="{ exact: true }" aria-haspopup="true">
                            <a routerLink="/profiles" class="m-menu__link">
                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                    <span></span>
                                </i>
                                <span class="m-menu__link-text">
                                    Profiles
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li> -->
        </ul>
    </div>
    <!-- END: Aside Menu -->
</div>
<!-- END: Left Aside -->
